import React from "react";
import Header from "../../../../Components/Header";
import SalesReturn from "./SalesReturn";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";

const EditSalesReturn = () => {
  const location = useLocation();

  const deliveryNoteId = location.state?.delivery_note_id;
    const picklist_id = location.state?.picklist_id;

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				  <title>Sales Return - Create</title>
			  </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <SalesReturn deliveryNoteId={deliveryNoteId} />
      </div>
  </div>
  );
};

export default EditSalesReturn;
